import { render, staticRenderFns } from "./ExportStaffInsurance.vue?vue&type=template&id=8987694e"
import script from "./ExportStaffInsurance.vue?vue&type=script&lang=js"
export * from "./ExportStaffInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports